
import { Tables } from "@/integrations/supabase/types";
import { ActivityCard } from "./ActivityCard";

type Activity = Tables<"activities">;

interface ActivitiesGridProps {
  activities: Activity[];
  onEdit: (activity: Activity) => void;
  onDelete: (activityId: string) => void;
}

export const ActivitiesGrid = ({ activities, onEdit, onDelete }: ActivitiesGridProps) => {
  return (
    <div className="grid gap-4">
      {activities.map((activity) => (
        <ActivityCard
          key={activity.id}
          activity={activity}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};
